// 보호 경로 가드. 앱 부트 시 /api/auth/status를 조회하고,
// unlocked=false면 /lock으로 리다이렉트한다.
// API 401 응답을 받으면 client.ts의 onUnauthorized 훅이 실행되어 역시 /lock으로 이동.
// 401 처리 시 hard reload(window.location.replace) 사용 — SPA navigate 대신 hard reload로
// React Query 캐시·observer를 완전 초기화해 무한 스피너 재발을 방지한다.

import { useEffect, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { setUnauthorizedHandler } from '../api/client';
import { useAuthStatus } from '../hooks/useAuthStatus';
import { Spinner } from './Spinner';
import { setLogoutReason } from '../utils/logoutReason';

interface Props {
  children: ReactNode;
}

export function RequireAuth({ children }: Props) {
  const qc = useQueryClient();
  const { data, isLoading } = useAuthStatus();

  useEffect(() => {
    // 401 훅 — 서버가 인증 만료를 알려주면 캐시 clear 후 hard reload로 /lock 진입
    setUnauthorizedHandler(() => {
      qc.clear();
      setLogoutReason('unauthorized');
      // hard reload — React 상태 전부 초기화, 무한 스피너 방지
      window.location.replace('/lock');
    });
    return () => setUnauthorizedHandler(() => {});
  }, [qc]);

  if (isLoading) return <Spinner label="로딩 중..." />;
  if (!data?.unlocked) return <Navigate to="/lock" replace />;
  return <>{children}</>;
}
